// Thin wrapper — canonical mobile detection lives in useMobileViewport.
// This file exists for shadcn UI compatibility (sidebar.tsx expects useIsMobile).
import { useMobileViewport } from "./useMobileViewport"

export function useIsMobile(): boolean {
  return useMobileViewport().isMobile
}
